export default "__VITE_ASSET__Dblwm3Cv__"